<template>
    <f7-page name="sendmoney-credit-checkout" id="page-sendmoney-credit-checkout" class="bg-color-white" @page:afterin="afterin">
        <f7-block>
            <!-- Your payment is being processed -->
            <!-- Successfully Update Payment. -->
            <!-- Payment Completed! -->
            <!-- We have received your Payment for your transaction(s).\nThank you for using WandrE! -->
            <!-- Once payment is received, a confirmation will be sent via push notification to the Mobile app or your registered email with Pay2Home, if any. -->
            <h1 class="text-center">{{ status==1 ? $t('sendmoney-checkout-status1') : (status==4 ? '' : $t('sendmoney-checkout-status')) }}</h1>
        </f7-block>
    </f7-page>
</template>

<script>
    import { mapActions } from "vuex";

    export default {
        mounted (){
            this.determineAppBranchId(this.$f7.device.desktop)
            this.status = this.$f7route.query['status'];
            // this.$f7route.query['cko-payment-id']
            if(this.status == 1) {
                this.checkoutSuccess();
            } else if(this.status == 4) {
                this.showPreloader();
            } else {
                this.hideTheSheet();
            }
        },
        data() {
            return {
                status: 3, // 1: Success, 2: Failed, 3: Cancel, 4: Loading Bar
            }
        },
        methods: {
            ...mapActions('misc', ['determineAppBranchId']),
            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },
            checkoutSuccess() {
                const self = this;
                self.showPreloader();
                this.$api.settlement.checkoutCreditStatus().then(function(response) {
                    self.hidePreloader();
                    if(response != '90008') {
                        self.hideTheSheet();
                    }
                });
            },
            hideTheSheet() {
                if(window.parent.hideTheSheet && window.parent.hideTheSheet != undefined) {
                    window.parent.hideTheSheet(true);
                } else {
                    window.opener.checkoutCompleted(true);
                }
            }
        },
        computed: {

        }
    }
</script>